import { EMPTY_STRING } from '../../../constants/common'
import {
  DOC_FLOW_RESULT_EMAIL_STATUSES,
  DOC_FLOW_RESULT_EPOST_STATUSES,
  DOC_FLOW_RESULT_SEND_EMAIL_STATUS,
  DOC_FLOW_RESULT_SEND_EPOST_STATUS,
} from '../../../constants/docFlow'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

import {
  DOC_FLOW_RESULT_TABLE_CONFIG_URL,
  DOC_FLOW_RESULT_TABLE_FILTER_STATE_URL,
} from './DocFlowResult.constants'

function getErrorTooltip({ errors, t }) {
  const errorsString = errors.reduce((acc, cur) => {
    const error = cur.is_persistent ? t(cur.title) : cur.title

    return acc ? `${acc}, ${error}` : error
  }, EMPTY_STRING)

  return t('DocumentStapling.ResultPhaseErrorTooltipTitleKey', {
    error: errorsString,
  })
}

function getEpostErrorTooltip({ error, t }) {
  return t('DocFlow.ResultPhaseEpostErrorTooltipTitleKey', { error })
}

function getStatusesWithErrorTooltip({ errorStatusId, statuses, tooltip }) {
  return statuses.map((status, statusId) =>
    statusId === errorStatusId
      ? { ...status, showTooltip: true, tooltip }
      : status
  )
}

export function getResultTableApiUrls(id) {
  return {
    filterStateApi: `${DOC_FLOW_RESULT_TABLE_FILTER_STATE_URL}?object_id=${id}`,
    listApi: `${DOC_FLOW_API_URL}${id}/result-files/filter/`,
    tableConfigApi: DOC_FLOW_RESULT_TABLE_CONFIG_URL,
  }
}

export function getResultTableFilterApi(id) {
  return `/api/document-stapling/document-staplings/${id}/result-files/single-field/`
}

export function getDocFlowResultEmailStatuses({ errors, t }) {
  return getStatusesWithErrorTooltip({
    errorStatusId: DOC_FLOW_RESULT_SEND_EMAIL_STATUS.error,
    statuses: DOC_FLOW_RESULT_EMAIL_STATUSES,
    tooltip: getErrorTooltip({ errors, t }),
  })
}

export function getDocFlowResultEpostStatuses({ error, t }) {
  return getStatusesWithErrorTooltip({
    errorStatusId: DOC_FLOW_RESULT_SEND_EPOST_STATUS.error,
    statuses: DOC_FLOW_RESULT_EPOST_STATUSES,
    tooltip: getEpostErrorTooltip({ error, t }),
  })
}
